// API
import { tmxApiCall } from './index'

export default {
  async getApprovalAmount (attachedId, productType) {
    return tmxApiCall('get', '/approvalAmount', {
      params: {
        attachedId,
        productType
      }
    })
  }
}
